import * as React from "react";
import PropTypes from 'prop-types';

const SvgHeaderSearchIcon = props => {
  if (props.id !== "_svgheadersearchicon") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M23.547 20.853c-.676-.623-5.88-5.663-7.111-6.855a8.884 8.884 0 001.562-5.042c0-4.946-4.03-8.956-9-8.956S0 4.01 0 8.956s4.029 8.956 8.999 8.956a8.986 8.986 0 004.792-1.377c1.119 1.105 6.371 6.286 7.087 6.94a1.64 1.64 0 001.115.441c.496 0 1.004-.225 1.412-.665.72-.778.781-1.809.142-2.398zM2.191 8.956C2.191 5.22 5.245 2.18 9 2.18s6.808 3.039 6.808 6.775-3.054 6.775-6.808 6.775S2.19 12.69 2.19 8.956z" /></svg>;
};

SvgHeaderSearchIcon.displayName = "_svgheadersearchicon";
SvgHeaderSearchIcon.propTypes = {
  id: PropTypes.string
};
SvgHeaderSearchIcon.defaultProps = {
  id: ''
};
export default SvgHeaderSearchIcon;